import styled from "@emotion/styled";
import { SpaceProps, space,  } from "styled-system";

export const Box = styled("div")<SpaceProps>`
  ${space}
`;
